module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/logo-american-apparel-b1a09fa3f15b8de647967f86f6a9ddee.svg";